/* eslint-disable no-underscore-dangle */

const _ = require('lodash');

class ScheduleTypeRenderer {
  constructor(model) {
    this._model = model;
    this._rootElem = document.createElement('schedule-type-column');
    this._rootElem.component = this._model;

    this._onceIcon = document.createElement('div');
    this._onceIcon.classList.add('glu-icon-button__icon', 'g-icon', 'glu-flex', 'g-icon-once');
    this._onceIcon.setAttribute('title', 'Once');

    this._repeatIcon = document.createElement('div');
    this._repeatIcon.classList.add('glu-icon-button__icon', 'g-icon', 'glu-flex', 'g-icon-repeat');
    this._repeatIcon.setAttribute('title', 'Repeat');

    this._unknownIcon = document.createElement('div');
    this._unknownIcon.classList.add(
      'glu-icon-button__icon',
      'g-icon',
      'glu-flex',
      'g-icon-unknown'
    );
    this._unknownIcon.setAttribute('title', 'Unknown');

    this._registerListeners();
    this.render();
  }

  /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
  _shutdown() {
    return new Promise((resolve /* ,reject */) => {
      this._unregisterListeners();

      this._onceIcon.remove();
      this._onceIcon = undefined;

      this._repeatIcon.remove();
      this._repeatIcon = undefined;

      this._unknownIcon.remove();
      this._unknownIcon = undefined;

      this._model = undefined;
      this._rootElem.remove();
      this._rootElem = undefined;
      resolve();
    });
  }

  _registerListeners() {
    this._model.on('ScheduleType', (this._onScheduleType = this._onScheduleType.bind(this)));
  }

  _unregisterListeners() {
    this._model.removeAllListeners('ScheduleType');
  }

  /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
  /**
   * Stateless method to completely rebuild this component from the _rootElem down.
   * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
   * Promise is returned the caller will assume the Renderer has completed rendering.
   */
  render() {
    this._setScheduleType(this._model.getScheduleType());
    return Promise.resolve();
  }

  get rootElement() {
    return this.getRootElement();
  }

  getRootElement() {
    return this._rootElem;
  }

  get model() {
    return this.getModel();
  }

  getModel() {
    return this._model;
  }

  /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

  _onScheduleType(newVal) {
    this._setScheduleType(newVal);
  }

  /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

  _setScheduleType(newVal) {
    this._rootElem.innerHTML = '';
    if (!_.isEmpty(newVal)) {
      switch (newVal) {
        case 'one':
          this._rootElem.appendChild(this._onceIcon);
          break;

        default:
          this._rootElem.appendChild(this._repeatIcon);
          break;
      }
    } else {
      this._rootElem.innerHTML = '';
    }
  }

  /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

export default ScheduleTypeRenderer;
